module.exports = __webpack_public_path__ + "img/triangle_shape.d5a5f36d.svg";